import { render, staticRenderFns } from "./FooterCommonGm99.vue?vue&type=template&id=1dbfd482&scoped=true&"
import script from "./FooterCommonGm99.vue?vue&type=script&lang=js&"
export * from "./FooterCommonGm99.vue?vue&type=script&lang=js&"
import style0 from "./FooterCommonGm99.vue?vue&type=style&index=0&id=1dbfd482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbfd482",
  null
  
)

component.options.__file = "FooterCommonGm99.vue"
export default component.exports